// extracted by mini-css-extract-plugin
export var equalColumn = "_hg-0";